import {
  Button,
  Col,
  Input,
  message,
  Popconfirm,
  Row,
  Table,
  Typography,
} from 'antd';
import styled from 'styled-components';

import { ColumnsType } from 'antd/lib/table';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { selectUser } from '../../../../auth/states/userSlice';
import { IPermission } from '../../../../common/types/commonTypes';
import BreadCrumb from '../../../../components/common/breadCrumb/BreadCrumb';
import { loadingIndicator } from '../../../../components/common/spinner/LoadingIndicator';
import {
  useDeleteCancelHajiPreregMutation,
  useGetAllHajiPreRegQuery,
} from '../../API/Endpoints/HajjiManageMentEndspont';
import { IAllCancelPreReg } from '../../Types/HajjiManagement.interface';

type Props = { permission?: IPermission };

const CancelPreRegAll = ({ permission }: Props) => {
  const user = useSelector(selectUser);
  const {
    data: cancelPreReg,
    isLoading,
    refetch,
    isFetching,
  } = useGetAllHajiPreRegQuery();
  const allCancelPreReg = cancelPreReg?.data;
  const [
    deleteCancelPreReg,
    { isError, isLoading: deleteLoading, isSuccess, error },
  ] = useDeleteCancelHajiPreregMutation();

  useEffect(() => {
    if (isSuccess) {
      message.success('Deleted Successfully!');
    }
    if (isError) {
      message.error('Thare was an error!');
    }
  }, [deleteLoading]);

  const columns: ColumnsType<IAllCancelPreReg> = [
    {
      title: 'SL.',

      render: (_, data, index) => <> {index + 1} </>,
    },
    {
      title: 'Tracking Number',
      dataIndex: 'cancel_track_tracking_no',
      key: 'cancel_track_tracking_no',
    },
    {
      title: 'Office Charge',
      dataIndex: 'cancel_office_charge',
      key: 'cancel_office_charge',
    },
    {
      title: 'Govt Charge',
      dataIndex: 'cancel_govt_charge',
      key: 'cancel_govt_charge',
    },
    {
      title: 'Total Charge',
      dataIndex: 'cancel_total_charge',
      key: 'cancel_total_charge',
    },

    {
      title: 'Cancel Date',
      dataIndex: 'date',
      key: 'date',
    },

    {
      title: 'Action',
      key: 'operation',
      width: 100,

      render: (_, data) => (
        <Popconfirm
          onConfirm={() =>
            deleteCancelPreReg({
              cancel_id: data?.cancel_id,
              deleted_by: user?.user_id as number,
            })
          }
          title='Sure to delete?'
          disabled={!permission?.['delete:any']}
        >
          {permission?.['delete:any'] && (
            <Button
              size='small'
              type='primary'
              style={{ background: '#e90800', border: 'none' }}
              loading={deleteLoading}
            >
              <Typography style={{ color: '#fff' }}>Delete</Typography>
            </Button>
          )}
        </Popconfirm>
      ),
    },
  ];
  return (
    <ViewInvoiceStyle>
      <BreadCrumb
        arrOfOption={['Hajji Pre Registration', 'List']}
        refetch={refetch}
        reloaderSize='small'
      />

      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 24 }}>
        <Col
          span={6}
          xs={24}
          sm={24}
          md={24}
          lg={19}
          style={{ marginBottom: '1rem' }}
        >
          {permission?.['create:any'] && (
            <Link
              to='/haji/transfer/cancel_pre_registration'
              state={location.pathname}
            >
              <Button type='primary'>Create</Button>
            </Link>
          )}
        </Col>

        <Col span={6} xs={24} sm={24} md={24} lg={5}>
          <Input placeholder='🔍 Search' />
        </Col>
      </Row>

      <Table
        size='small'
        bordered
        rowKey={(e) => e.cancel_track_tracking_no}
        pagination={
          allCancelPreReg && allCancelPreReg.length > 20
            ? {
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '50'],
              }
            : false
        }
        columns={columns}
        dataSource={allCancelPreReg}
        scroll={{ x: true }}
        loading={{
          spinning: isLoading || isFetching,
          indicator: loadingIndicator,
        }}
      />
    </ViewInvoiceStyle>
  );
};

export default CancelPreRegAll;

const ViewInvoiceStyle = styled.div`
  .transfer-in-list {
    border: 1px solid lightgray;
    width: 100%;
  }

  .transfer-in-list .transfer-in-list-td > td {
    padding: 10px !important;
    border-bottom: 1px solid lightgray;
    font-size: 13px !important;
  }

  .transfer-in-list .ant-table-thead .ant-table-cell {
    padding: 7px !important;
    font-size: 13px !important;
    border-bottom: 1px solid lightgray;
  }
`;
